/* @generated */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var props = __getOwnPropSymbols(b), i = 0, n = props.length, prop; i < n; i++) {
      prop = props[i];
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = function(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function(target, all) {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = function(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function")
    for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: function(k) {
          return from[k];
        }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
  return to;
};
var __toESM = function(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  );
};
var __toCommonJS = function(mod) {
  return __copyProps(__defProp({}, "__esModule", { value: true }), mod);
};

// ../src/tooltips/index.ts
var tooltips_exports = {};
__export(tooltips_exports, {
  Control: function() {
    return Control;
  },
  Toggletip: function() {
    return Toggletip;
  },
  Tooltip: function() {
    return Tooltip;
  }
});
module.exports = __toCommonJS(tooltips_exports);

// ../src/tooltips/control.tsx
var import_classnames = __toESM(require("classnames"));
var React = __toESM(require("react"));
var import_react_transition_group = require("react-transition-group");
var import_motion = require("@dropbox/dig-components/motion");
var import_overlay = require("@dropbox/dig-components/overlay");
var import_typography = require("@dropbox/dig-components/typography");
var import_dig_foundations = require("@dropbox/dig-foundations");
var import_web = require("@react-hookz/web");

// ../src/tooltips/index.css.ts
var import_createRuntimeFn = require("@vanilla-extract/recipes/createRuntimeFn");
var actions = "dig-1i767qdh_21-1-1";
var fullBleed = "dig-1i767qdj_21-1-1";
var illustration = "dig-1i767qdk_21-1-1";
var subtext = "dig-1i767qdi_21-1-1";
var text = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1i767qdl_21-1-1", variantClassNames: { withMargin: { true: "dig-1i767qdm_21-1-1", false: "dig-1i767qdn_21-1-1" } }, defaultVariants: { withMargin: false }, compoundVariants: [] });
var tooltip = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1i767qd0_21-1-1", variantClassNames: { shouldDisablePointerEvents: { true: "dig-1i767qd1_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var tooltipArrow = "dig-1i767qdo_21-1-1";
var tooltipContent = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1i767qda_21-1-1", variantClassNames: { variant: { basic: "dig-1i767qdb_21-1-1", rich: "dig-1i767qdc_21-1-1 dig-1i767qd9_21-1-1" }, placement: { up: "dig-1i767qdd_21-1-1", down: "dig-1i767qde_21-1-1", left: "dig-1i767qdf_21-1-1", right: "dig-1i767qdg_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var tooltipInner = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1i767qd2_21-1-1", variantClassNames: { placement: { up: "dig-1i767qd3_21-1-1", down: "dig-1i767qd4_21-1-1", left: "dig-1i767qd5_21-1-1", right: "dig-1i767qd6_21-1-1" }, variant: { basic: "dig-1i767qd7_21-1-1", rich: "dig-1i767qd8_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });

// ../src/tooltips/control.tsx
var import_aspect_ratio = require("@dropbox/dig-components/aspect_ratio");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["id", "className", "children", "open", "boundary", "placement", "variant", "triggerRef", "shouldReturnFocus", "shouldDisablePointerEvents", "inverse", "openDelay", "maxWidth", "onDisplayed", "onHidden", "contentBreak", "isPortaled", "offsetDistance", "auto", "autoHide", "onChangePlacement", "_isUnsafelyOverridingTheme", "withIllustration"];
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
var tooltipPlacementTransitionDir = {
  top: "up",
  "top-start": "up",
  "top-end": "up",
  bottom: "down",
  "bottom-start": "down",
  "bottom-end": "down",
  left: "left",
  "left-start": "left",
  "left-end": "left",
  right: "right",
  "right-start": "right",
  "right-end": "right"
};
var getTransitionInByPlacement = function(placement) {
  return {
    transitions: [{
      property: tooltipPlacementTransitionDir[placement],
      value: 16
    }, {
      property: "opacity",
      value: 1
    }],
    easing: "enter",
    duration: 125
  };
};
var TRANSITION_OUT = {
  transitions: [{
    property: "opacity",
    value: 0
  }],
  easing: "leave",
  duration: 125
};
var RenderAfter = function(_ref) {
  var children = _ref.children, update = _ref.update;
  var _React$useState = React.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), nextTick = _React$useState2[0], setNextTick = _React$useState2[1];
  React.useEffect(function() {
    setTimeout(function() {
      setNextTick(true);
    }, 0);
  }, []);
  (0, import_web.useIsomorphicLayoutEffect)(function() {
    if (nextTick && update) {
      update();
    }
  }, [nextTick, update]);
  return nextTick ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : null;
};
var Control = React.forwardRef(function(_ref2, ref) {
  var id = _ref2.id, className = _ref2.className, children = _ref2.children, open = _ref2.open, boundary = _ref2.boundary, _ref2$placement = _ref2.placement, _initialPlacement = _ref2$placement === void 0 ? "bottom" : _ref2$placement, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "basic" : _ref2$variant, triggerRef = _ref2.triggerRef, _ref2$shouldReturnFoc = _ref2.shouldReturnFocus, shouldReturnFocus = _ref2$shouldReturnFoc === void 0 ? true : _ref2$shouldReturnFoc, _ref2$shouldDisablePo = _ref2.shouldDisablePointerEvents, shouldDisablePointerEvents = _ref2$shouldDisablePo === void 0 ? false : _ref2$shouldDisablePo, _ref2$inverse = _ref2.inverse, inverse = _ref2$inverse === void 0 ? true : _ref2$inverse, _ref2$openDelay = _ref2.openDelay, openDelay = _ref2$openDelay === void 0 ? 0 : _ref2$openDelay, _ref2$maxWidth = _ref2.maxWidth, maxWidth = _ref2$maxWidth === void 0 ? 256 : _ref2$maxWidth, onDisplayed = _ref2.onDisplayed, onHidden = _ref2.onHidden, contentBreak = _ref2.contentBreak, _ref2$isPortaled = _ref2.isPortaled, isPortaled = _ref2$isPortaled === void 0 ? true : _ref2$isPortaled, offsetDistance = _ref2.offsetDistance, auto = _ref2.auto, _ref2$autoHide = _ref2.autoHide, autoHide = _ref2$autoHide === void 0 ? false : _ref2$autoHide, onChangePlacement = _ref2.onChangePlacement, _ref2$_isUnsafelyOver = _ref2._isUnsafelyOverridingTheme, _isUnsafelyOverridingTheme = _ref2$_isUnsafelyOver === void 0 ? false : _ref2$_isUnsafelyOver, withIllustration = _ref2.withIllustration, rest = _objectWithoutProperties(_ref2, _excluded);
  var _React$useState3 = React.useState(_initialPlacement), _React$useState4 = _slicedToArray(_React$useState3, 2), floatingPlacement = _React$useState4[0], setFloatingPlacement = _React$useState4[1];
  var _React$useState5 = React.useState(_initialPlacement), _React$useState6 = _slicedToArray(_React$useState5, 2), prevInitialPlacement = _React$useState6[0], setPrevInitialPlacement = _React$useState6[1];
  if (_initialPlacement !== prevInitialPlacement) {
    setPrevInitialPlacement(_initialPlacement);
    setFloatingPlacement(_initialPlacement);
  }
  var overlayRef = React.useRef(null);
  var _React$useState7 = React.useState(false), _React$useState8 = _slicedToArray(_React$useState7, 2), hasShownTooltip = _React$useState8[0], setHasShownTooltip = _React$useState8[1];
  var _useTheme = (0, import_dig_foundations.useTheme)(), getInverseProps = _useTheme.getInverseProps, getThemeProps = _useTheme.getThemeProps, theme = _useTheme.theme;
  var arrowRef = React.useRef(null);
  var inverseModeClassName = _isUnsafelyOverridingTheme === false ? (0, import_classnames.default)(_defineProperty(_defineProperty({}, getInverseProps().className, inverse), getThemeProps().className, !inverse)) : void 0;
  var cls = (0, import_classnames.default)("dig-Tooltip", "dig-Tooltip--".concat(variant), "dig-Tooltip--".concat(floatingPlacement), tooltip({
    shouldDisablePointerEvents: shouldDisablePointerEvents
  }), className, inverseModeClassName, {
    "dig-Tooltip--shouldDisablePointerEvents": shouldDisablePointerEvents
  });
  var contentBreakProperty = contentBreak === "character" ? "break-all" : "normal";
  var styl = {
    maxWidth: maxWidth,
    wordBreak: contentBreakProperty
  };
  var arrowPadding = React.useMemo(function() {
    if (variant === "rich") {
      return 26;
    } else if (floatingPlacement.includes("top") || floatingPlacement.includes("bottom")) {
      return 14;
    } else {
      return 10;
    }
  }, [variant, floatingPlacement]);
  React.useEffect(function() {
    if (open) {
      var _id = window.setTimeout(function() {
        setHasShownTooltip(true);
      }, openDelay);
      return function() {
        window.clearTimeout(_id);
      };
    } else {
      setHasShownTooltip(false);
    }
  }, [open]);
  (0, import_web.useUpdateEffect)(function() {
    if (!hasShownTooltip) {
      if (shouldReturnFocus) {
        if (triggerRef && triggerRef.current) {
          if ("focus" in triggerRef.current && typeof triggerRef.current.focus === "function") {
            triggerRef.current.focus();
          }
        }
      }
    }
  }, [hasShownTooltip]);
  React.useImperativeHandle(ref, function() {
    return {
      update: function() {
        if (overlayRef.current) {
          overlayRef.current.update();
        }
      }
    };
  });
  var hasIllustration = variant === "rich" && withIllustration;
  return /* @__PURE__ */ React.createElement(import_react_transition_group.TransitionGroup, { component: null }, open && hasShownTooltip && /* @__PURE__ */ React.createElement(import_motion.Motion, { transitionIn: getTransitionInByPlacement(floatingPlacement), transitionOut: TRANSITION_OUT, onEntered: onDisplayed, onExited: onHidden }, function(_ref3) {
    var style = _ref3.style;
    return /* @__PURE__ */ React.createElement(
      import_overlay.Overlay,
      __spreadValues({
        id: id,
        role: "tooltip",
        placement: _initialPlacement,
        boundaryRef: boundary,
        anchorRef: triggerRef,
        className: cls,
        ref: overlayRef,
        style: styl,
        isPortaled: isPortaled,
        arrowRef: arrowRef,
        offsetDistance: offsetDistance,
        auto: auto,
        shouldHideOnAnchorHidden: autoHide,
        onChangePlacement: function(newPlacement) {
          setFloatingPlacement(newPlacement);
          if (onChangePlacement)
            onChangePlacement(newPlacement);
        },
        _arrowPadding: theme === "vis2023" ? arrowPadding : void 0
      }, rest),
      /* @__PURE__ */ React.createElement("div", { className: (0, import_classnames.default)("dig-Tooltip-inner", tooltipInner({
        placement: tooltipPlacementTransitionDir[floatingPlacement],
        variant: variant
      })), style: style }, /* @__PURE__ */ React.createElement("div", { className: (0, import_classnames.default)("dig-Tooltip-content", tooltipContent({
        variant: variant,
        placement: tooltipPlacementTransitionDir[floatingPlacement]
      })), "data-testid": "digTooltipContent" }, hasIllustration && /* @__PURE__ */ React.createElement("div", { className: fullBleed }, /* @__PURE__ */ React.createElement(import_aspect_ratio.AspectRatio, { ratio: 1 / 1, maxHeight: 128, className: illustration }, withIllustration)), /* @__PURE__ */ React.createElement(import_typography.Text, { className: "dig-Tooltip-content--text", tagName: "div", size: "small" }, isPortaled && variant === "rich" ? /* @__PURE__ */ React.createElement(RenderAfter, { update: overlayRef.current ? overlayRef.current.update : void 0 }, children) : children)), /* @__PURE__ */ React.createElement("span", { className: (0, import_classnames.default)("dig-Tooltip-arrow", tooltipArrow), ref: arrowRef }))
    );
  }));
});
Control.displayName = "Control";

// ../src/tooltips/toggletip.tsx
var React2 = __toESM(require("react"));

// ../src/_global/constants.ts
var ESC_KEY = "Escape";
var VISUALLY_HIDDEN_CSS = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "0 -1px -1px 0",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = "[".concat(buttonDataAttributeName, "]");
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = "[".concat(buttonContentDataAttributeName, "]");
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = "[".concat(splitButtonDataAttributeName, "]");
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = "[".concat(iconButtonDataAttributeName, "]");

// ../src/tooltips/toggletip.tsx
var import_buttons = require("@dropbox/dig-components/buttons");
var import_dig_icons = require("@dropbox/dig-icons");
var import_click_outside = require("@dropbox/dig-components/click_outside");
var import_assets = require("@dropbox/dig-icons/assets");

// ../src/_global/sizes.tsx
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getMigratedComponentSize = function(size) {
  var mapping = deprecationMap.find(function(_ref3) {
    var _ref4 = _slicedToArray2(_ref3, 2), _newVal = _ref4[0], deprecatedVal = _ref4[1];
    return size === deprecatedVal;
  });
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/tooltips/toggletip.tsx
var _excluded2 = ["className", "title", "placement", "auto", "boundary", "inverse", "openDelay", "aria-label", "iconButtonSize", "src"];
function _slicedToArray3(arr, i) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i) || _unsupportedIterableToArray3(arr, i) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit3(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Toggletip = React2.forwardRef(function(_ref, ref) {
  var className = _ref.className, title = _ref.title, _ref$placement = _ref.placement, initialPlacement = _ref$placement === void 0 ? "top" : _ref$placement, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? true : _ref$auto, boundary = _ref.boundary, inverse = _ref.inverse, _ref$openDelay = _ref.openDelay, openDelay = _ref$openDelay === void 0 ? 0 : _ref$openDelay, ariaLabel = _ref["aria-label"], _ref$iconButtonSize = _ref.iconButtonSize, _iconButtonSize = _ref$iconButtonSize === void 0 ? "small" : _ref$iconButtonSize, _ref$src = _ref.src, src = _ref$src === void 0 ? import_assets.InfoLine : _ref$src, rest = _objectWithoutProperties2(_ref, _excluded2);
  var _React$useState = React2.useState(false), _React$useState2 = _slicedToArray3(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
  var _React$useState3 = React2.useState(initialPlacement), _React$useState4 = _slicedToArray3(_React$useState3, 2), placement = _React$useState4[0], setPlacement = _React$useState4[1];
  var triggerRef = React2.useRef(null);
  var iconButtonSize = getMigratedComponentSize(_iconButtonSize);
  var show = function() {
    return setOpen(true);
  };
  var hide = function() {
    setOpen(false);
    setPlacement(initialPlacement);
  };
  var updatePlacement = function(placement2) {
    setPlacement(placement2);
  };
  var handleClick = function() {
    if (open) {
      hide();
    } else {
      show();
    }
  };
  var handleClickOutside = function() {
    hide();
  };
  var handleKeyPress = function(evt) {
    if (evt.key === ESC_KEY) {
      hide();
    }
  };
  var iconButtonProps = {
    "aria-label": ariaLabel,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    inverse: inverse
  };
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(import_click_outside.ClickOutside, { className: "dig-Toggletip-backdrop", isActive: open, onClickOutside: handleClickOutside, "data-testid": "digToggletipBackdrop" }, /* @__PURE__ */ React2.createElement(import_buttons.IconButton, __spreadProps(__spreadValues({ variant: "transparent", ref: triggerRef }, iconButtonProps), { size: iconButtonSize, type: "button" }), /* @__PURE__ */ React2.createElement(import_dig_icons.UIIcon, { src: src, size: iconButtonSize })), /* @__PURE__ */ React2.createElement(Control, __spreadValues({ triggerRef: triggerRef, open: open, auto: true, placement: placement, onChangePlacement: updatePlacement, boundary: boundary, shouldReturnFocus: false, openDelay: openDelay, ref: ref }, rest), title)), /* @__PURE__ */ React2.createElement("div", { role: "log", "aria-live": "assertive", "aria-relevant": "additions", style: VISUALLY_HIDDEN_CSS }, open && title));
});
Toggletip.displayName = "Toggletip";

// ../src/tooltips/tooltip.tsx
var React7 = __toESM(require("react"));
var import_hooks = require("@dropbox/dig-components/hooks");

// ../src/tooltips/title.tsx
var React3 = __toESM(require("react"));
var import_typography2 = require("@dropbox/dig-components/typography");
var _excluded3 = ["children", "tagName", "color", "size"];
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Title = function(_ref) {
  var children = _ref.children, _ref$tagName = _ref.tagName, tagName = _ref$tagName === void 0 ? "div" : _ref$tagName, _ref$color = _ref.color, color = _ref$color === void 0 ? "inherit" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, rest = _objectWithoutProperties3(_ref, _excluded3);
  return /* @__PURE__ */ React3.createElement(import_typography2.Title, __spreadProps(__spreadValues({}, rest), { color: color, size: size, tagName: tagName }), children);
};

// ../src/tooltips/text.tsx
var React4 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));
var import_typography3 = require("@dropbox/dig-components/typography");
var _excluded4 = ["children", "className", "color", "size", "tagName", "withMargin"];
function _objectWithoutProperties4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Text2 = function(_ref) {
  var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$color = _ref.color, color = _ref$color === void 0 ? "inherit" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, _ref$tagName = _ref.tagName, tagName = _ref$tagName === void 0 ? "p" : _ref$tagName, _ref$withMargin = _ref.withMargin, withMargin = _ref$withMargin === void 0 ? true : _ref$withMargin, rest = _objectWithoutProperties4(_ref, _excluded4);
  var cls = (0, import_classnames2.default)(text({
    withMargin: withMargin
  }), className);
  return /* @__PURE__ */ React4.createElement(import_typography3.Text, __spreadProps(__spreadValues({}, rest), { color: color, size: size, tagName: tagName, className: cls, _withMargins: false }), children);
};

// ../src/tooltips/actions.tsx
var React5 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var _excluded5 = ["children", "className"];
function _objectWithoutProperties5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Actions = function(_ref) {
  var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = _objectWithoutProperties5(_ref, _excluded5);
  var cls = (0, import_classnames3.default)(actions, className);
  return /* @__PURE__ */ React5.createElement("div", __spreadValues({ className: cls }, rest), children);
};

// ../src/tooltips/subtext.tsx
var React6 = __toESM(require("react"));
var import_classnames4 = __toESM(require("classnames"));
var import_typography4 = require("@dropbox/dig-components/typography");
var _excluded6 = ["children", "className"];
function _objectWithoutProperties6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var Subtext = function(_ref) {
  var children = _ref.children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = _objectWithoutProperties6(_ref, _excluded6);
  var cls = (0, import_classnames4.default)(subtext, className);
  return /* @__PURE__ */ React6.createElement(import_typography4.Text, __spreadValues({ tagName: "span", color: "subtle", className: cls }, rest), children);
};

// ../src/tooltips/tooltip.tsx
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var _excluded7 = ["id", "children", "title", "placement", "auto", "boundary", "shouldCloseOnClick", "openDelay", "maxWidth", "triggerRef", "inverse", "contentBreak", "offsetDistance", "autoHide", "onDisplayed", "onHidden"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty2(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty2(obj, key, value) {
  key = _toPropertyKey2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : String(i);
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _slicedToArray4(arr, i) {
  return _arrayWithHoles4(arr) || _iterableToArrayLimit4(arr, i) || _unsupportedIterableToArray4(arr, i) || _nonIterableRest4();
}
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit4(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles4(arr) {
  if (Array.isArray(arr))
    return arr;
}
var mergeEventProps = function(children, props) {
  var merged = {};
  var _loop = function() {
    var _Object$entries$_i = _slicedToArray4(_Object$entries[_i], 2), eventName = _Object$entries$_i[0], handler = _Object$entries$_i[1];
    merged[eventName] = function(evt) {
      handler(evt);
      if (React7.isValidElement(children) && children.props[eventName])
        children.props[eventName](evt);
    };
  };
  for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
    _loop();
  }
  return merged;
};
var Tooltip = React7.forwardRef(function(_ref, ref) {
  var id = _ref.id, children = _ref.children, title = _ref.title, _ref$placement = _ref.placement, initialPlacement = _ref$placement === void 0 ? "top" : _ref$placement, _ref$auto = _ref.auto, auto = _ref$auto === void 0 ? true : _ref$auto, boundary = _ref.boundary, _ref$shouldCloseOnCli = _ref.shouldCloseOnClick, shouldCloseOnClick = _ref$shouldCloseOnCli === void 0 ? false : _ref$shouldCloseOnCli, _ref$openDelay = _ref.openDelay, openDelay = _ref$openDelay === void 0 ? 0 : _ref$openDelay, maxWidth = _ref.maxWidth, reusedTriggerRef = _ref.triggerRef, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? true : _ref$inverse, contentBreak = _ref.contentBreak, offsetDistance = _ref.offsetDistance, _ref$autoHide = _ref.autoHide, autoHide = _ref$autoHide === void 0 ? false : _ref$autoHide, onDisplayed = _ref.onDisplayed, onHidden = _ref.onHidden, rest = _objectWithoutProperties7(_ref, _excluded7);
  var tooltipId = (0, import_hooks.useUniqueId)({
    prefix: "dig-Tooltip-",
    idOverride: id
  });
  var _React$useState = React7.useState(false), _React$useState2 = _slicedToArray4(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
  var _React$useState3 = React7.useState(false), _React$useState4 = _slicedToArray4(_React$useState3, 2), displayed = _React$useState4[0], setDisplayed = _React$useState4[1];
  var _React$useState5 = React7.useState(initialPlacement), _React$useState6 = _slicedToArray4(_React$useState5, 2), placement = _React$useState6[0], setPlacement = _React$useState6[1];
  var triggerRef = reusedTriggerRef || React7.useRef(null);
  var controlRef = React7.useRef(null);
  var show = function() {
    return setOpen(true);
  };
  var hide = function() {
    setOpen(false);
    setDisplayed(false);
    setPlacement(initialPlacement);
  };
  var handleDisplayed = function() {
    if (onDisplayed)
      onDisplayed();
    setDisplayed(true);
  };
  var updatePlacement = function(placement2) {
    setPlacement(placement2);
  };
  var handleClick = function() {
    if (shouldCloseOnClick)
      hide();
  };
  var handleKeyPress = function(evt) {
    if (evt.key === ESC_KEY) {
      hide();
    }
  };
  var attachKeydown = function() {
    document.addEventListener("keydown", handleKeyPress);
  };
  var removeKeydown = function() {
    document.removeEventListener("keydown", handleKeyPress);
  };
  React7.useEffect(function() {
    if (open)
      attachKeydown();
    else
      removeKeydown();
    return function() {
      return removeKeydown();
    };
  }, [open]);
  var childrenProps = _objectSpread({
    /**
     * Using `aria-describedby` over `aria-labelledby` since the tooltip content is an additional
     * hint on top of the trigger's own content.
     *
     * Note that it's only set when tooltip is actually displayed, since AT
     * requires the referenced element (i.e. tooltip contents) to present in
     * the DOM to work.
     *
     * Example: AT will first read the Button, then the aria-describedby as a hint.
     */
    "aria-describedby": open && displayed ? tooltipId : void 0
  }, mergeEventProps(children, {
    onMouseEnter: show,
    onMouseLeave: hide,
    onFocus: show,
    onBlur: hide,
    onClick: handleClick
  }));
  React7.useImperativeHandle(ref, function() {
    return {
      update: function() {
        if (controlRef.current) {
          controlRef.current.update();
        }
      }
    };
  });
  React7.useEffect(function() {
    if (controlRef && controlRef.current)
      controlRef.current.update();
  }, [title]);
  return /* @__PURE__ */ React7.createElement(
    React7.Fragment,
    null,
    /**
     * We need to extend the passed in Buttons, Controls, and any other interactive element
     * here since `aria-describedby` does not work with basic generic roles (i.e: span, div
     * without an explicit interactive role such as "button", "link", etc.)
     */
    React7.isValidElement(children) && React7.cloneElement(children, _objectSpread({
      ref: triggerRef
    }, childrenProps)),
    /* @__PURE__ */ React7.createElement(
      Control,
      __spreadValues({
        triggerRef: triggerRef,
        open: open,
        auto: true,
        autoHide: autoHide,
        maxWidth: maxWidth,
        placement: placement,
        onChangePlacement: updatePlacement,
        boundary: boundary,
        id: tooltipId,
        shouldDisablePointerEvents: true,
        shouldReturnFocus: false,
        openDelay: openDelay,
        onDisplayed: handleDisplayed,
        ref: controlRef,
        inverse: inverse,
        contentBreak: contentBreak,
        offsetDistance: offsetDistance,
        onHidden: onHidden
      }, rest),
      title
    )
  );
});
Tooltip.displayName = "Tooltip";
Tooltip.Control = Control;
Tooltip.Title = Title;
Tooltip.Text = Text2;
Tooltip.Actions = Actions;
Tooltip.Subtext = Subtext;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Control,
  Toggletip,
  Tooltip
});
